import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import './PatientsViewer.css'
import { Route, Switch } from 'react-router-dom'

import PatientViewerContainer from './PatientViewer/PatientViewerContainer'
import PatientSelector from './PatientSelector/PatientSelector'

const PatientsViewer = ({match, patients}) => {
  return <Fragment>
    <Switch>
      <Route
        exact
        path={`${match.url}/`}
        render={() => <PatientSelector match={match} recentPatients={patients} />} />
      <Route
        path={`${match.url}/:patientId`}
        render={props => (
          <PatientViewerContainer {...props} />
        )} />
    </Switch>
  </Fragment>
}

PatientsViewer.propTypes = {
  match: PropTypes.object.isRequired,
  patients: PropTypes.array.isRequired
}
export default PatientsViewer
